import React from "react";
import { Languages } from "lucide-react";

/**
 * Lightweight language toggle for PUBLIC, unauthenticated pages
 * (lead-capture form, customer quote page). Intentionally NOT wired to
 * LanguageContext so it does NOT touch localStorage `tasklio_lang` —
 * a customer flipping their language must never overwrite the business
 * owner's app-language preference.
 *
 * Props:
 *   lang     — current value: "en" | "es"
 *   setLang  — setter
 */
export const PublicLanguageToggle = ({ lang, setLang, testidPrefix = "public-lang-switch" }) => {
  const Btn = ({ value, label }) => {
    const active = lang === value;
    return (
      <button
        type="button"
        onClick={() => setLang(value)}
        className={
          "px-2.5 py-1 rounded-md text-xs font-semibold transition-colors " +
          (active
            ? "bg-white text-green-800 shadow-sm"
            : "text-gray-500 hover:text-gray-800")
        }
        data-testid={`${testidPrefix}-${value}`}
        aria-pressed={active}
      >
        {label}
      </button>
    );
  };

  return (
    <div
      className="inline-flex items-center gap-1 bg-gray-100 border border-gray-200 rounded-lg p-0.5"
      data-testid={testidPrefix}
    >
      <Languages className="w-3.5 h-3.5 text-gray-400 ml-1.5" aria-hidden="true" />
      <Btn value="en" label="EN" />
      <Btn value="es" label="ES" />
    </div>
  );
};
